// extracted by mini-css-extract-plugin
module.exports = {"birdImage":"_1sCwdz"};